export const CONSULT_PENDING = 0;
export const CONSULT_ACCEPTED = 1;
export const CONSULT_FINISHED = 2;
export const CONSULT_CANCELLED = 3;
export const CONSULT_TIMEOUT = 4;

export const CONTEXT_MENU_CONSULT_PATIENT = 0;
export const CONTEXT_MENU_CONSULT_SUMMARY = 1;
export const CONTEXT_MENU_CONSULT_DETAILS = 2;
export const CONTEXT_MENU_CONSULT_OPTIONS = 3;
export const CONTEXT_MENU_CONSULT_FEE = 4;
export const CONTEXT_MENU_ALL_MEDIA = 5;
export const CONTEXT_MENU_TERM_OF_CONSULT = 6;
export const CONTEXT_MENU_CONSULT_HISTORY = 7;
export const CONTEXT_MENU_SEARCH_MESSAGE = 8;
export const CONTEXT_MENU_REFERRAL_MEMO = 9;
export const CONTEXT_MENU_MC_HISTORY = 10;

export const CONSULT_PATIENT_REQUEST = 'request_consult';
export const CONSULT_PATIENT_CANCEL = 'patient_cancel_request';

export const CONSULT_DOCTOR_ACCEPTED = 'accept_chat_consult';
export const CONSULT_DOCTOR_FINISH = 'end_consult';
export const CONSULT_DOCTOR_EXPIRED = 'end_chat_consult';

export const CONSULT_TYPE_CHAT = 0;
export const CONSULT_TYPE_VIDEO = 1;
export const CONSULT_TYPE_FOLLOW_UP = 2;

export const INVITATION_ACCEPT = 1;
export const INVITATION_DENY = 0;

export const POOL_IN_STATUS = 1;

export const POOL_TYPE_MANADR = 1;
export const POOL_TYPE_SINGAPORE = 2;
export const POOL_TYPE_MERDEKA = 3;
export const POOL_TYPE_ASCOTT = 4;
export const POOL_TYPE_ORCHID = 5;

export const CONSULT_SOURCE_AUS = 8;
export const CONSULT_SOURCE_FOREIGN_WORKER_SINGAPORE = 9;
export const CONSULT_SOURCE_MERDEKA_CARD = 10;
export const CONSULT_SOURCE_MANADR_LITE = 12;
export const CONSULT_SOURCE_ORCHID_CARD = 13;
export const CONSULT_SOURCE_MANADR_SITE = 14;

export const CONSULT_VIDEO_CREATED = 0;
export const CONSULT_VIDEO_ENDED = 1;
export const ROOM_UPDATE_STATUS = 'update_video_room_status';

export const CONSULT_SOURCE_ASCOTT = 11;

export const PHARMACY_SOURCE_OTTER = 'ottersg';
export const PHARMACY_SOURCE_LIFEPACK = 'lifepack';
export const PHARMACY_SOURCE_MANADR = 'manadr';

export const FEE_MODEL = {
  FIXED: 'fixed',
  ACCUMULATIVE: 'accumulative',
};

export const POOL_REQUESTS_TAB_ID = 'pool-requests';

export const LifepackPrescriptionStatus = {
  IN_REVIEW: 'in_review',
  PRESCRIPTION_ADJUSTED: 'prescription_adjusted',
  PRESCRIPTION_APPROVED: 'prescription_approved',
  // The actual state when patient can pay for the prescription :)
  PENDING_ADDRESS: 'pending_address',
  PRESCRIPTION_REJECTED: 'prescription_rejected',
  ORDER_CANCELLED: 'order_cancelled',
  ORDER_EXPIRED: 'order_expired',
  PAYMENT_SUCCESSFUL: 'payment_successful',
  PAYMENT_FAILED: 'payment_failed',
};
